export default "__VITE_ASSET__DH1eqIJ8__"